export { default as en } from './en.json';
export { default as es } from './es.json';

export const NS = 'campaigns' as const;
